/**
 * HomeGate — what `/` renders.
 *
 * A guided member gets the home page bare (no sidebar, four sections);
 * everyone else gets the same page inside the app shell, at
 * /prioritization/dashboard on the web, or the App Layer launcher inside the
 * native shells. The profile is read from the membership row on the server,
 * never from browser storage, so it follows the person to any device.
 */

import { Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { useTenantStore } from '../../stores/prioritization/tenantStore';
import HomePage from './HomePage';
import { useExperienceProfile } from './useExperienceProfile';

export default function HomeGate() {
  const currentWorkspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const hasFetchedWorkspace = useTenantStore((s) => s.hasFetched);
  const profile = useExperienceProfile();

  const fallback = Capacitor.isNativePlatform() ? '/apps' : '/prioritization/dashboard';

  // No workspace resolved (yet, or at all): the home inside the shell says so
  // honestly, so send everyone there once we know.
  if (!currentWorkspaceId) {
    return hasFetchedWorkspace ? <Navigate to={fallback} replace /> : null;
  }
  if (profile === null) return null;
  if (profile === 'guided') return <HomePage profile="guided" />;
  return <Navigate to={fallback} replace />;
}
